/**
 * ReopenCardDialog — public entry point for the reopen-closed-card dialog
 * (SE-5496). Fully controlled: the owning ClosedArea holds selection/rationale
 * state. The Container owns no state either — it binds the per-stage handlers
 * and the submit gate the View may not derive itself (SE-8019).
 * @module features/player-kanban/components/molecules/ReopenCardDialog
 */

export { default } from "./ReopenCardDialogContainer";
export type { ReopenCardDialogContainerProps } from "./ReopenCardDialogContainer";
export type {
  ReopenCardDialogViewProps,
  ReopenStageOption,
} from "./ReopenCardDialogView";
